export function orderByIdAsc(data1: any, data2: any)
{
    return data1.id - data2.id;
}

export function orderByIdDesc(data1: any, data2: any)
{
    return data2.id - data1.id;
}